import type { ISbStoryData } from "storyblok";

export const useStoryblokSearch = () => {
  type SearchOptions = {
    query: string;
  };

  const config = useRuntimeConfig().public;
  const isPreview = config.CMS_ENV !== "production";

  const searchStoryblok = async (options: SearchOptions) => {
    const { query } = options;

    // Fetch all stories of the given type
    const { data } = await useStoryblokApi().get("cdn/stories/", {
      version: isPreview ? "draft" : "published",
      search_term: query,
      per_page: 100, // Increase if needed for better search coverage
    });

    // Perform a simple fuzzy search on the story name/title and content
    const filteredStories = (data?.stories || []).filter((story: ISbStoryData) => {
      if (!story.content) return false;
      const excludedPrefixes = ["data/", "global/", "api/", "success/", "_/", "unavailable"];
      if (excludedPrefixes.some((prefix) => story.full_slug.startsWith(prefix))) return false;
      if (story.content?.Noindex === true) return false;
      if (story.content?.redirect && (story.content?.redirect?.cached_url?.length > 0 || story.content?.redirect?.url?.length > 0)) return false;

      return true;
    });

    type StoryblokStory = {
      uuid: string;
      full_slug: string;
      name: string;
      content?: Record<string, unknown>;
    };
    const indexedStories: StoryblokStory[] = filteredStories.map((story: ISbStoryData) => {
      const breadcrumbs = story.full_slug.split("/").map((crumbs: string) => {
        return textTitleCase(crumbs);
      });

      let image = `${config.SITE_URL}/kudosity-social.jpg`;
      if (story?.content?.image?.filename) image = story?.content?.image?.filename;
      if (story.content && story.content.seo && story.content.seo && story.content.seo?.og_image) image = story?.content?.seo?.og_image;

      const description = story.content && story.content.seo ? story.content.seo.description : "";

      return {
        objectID: story.uuid,
        breadcrumbs: breadcrumbs.length > 0 ? breadcrumbs.slice(0, -1) : [],
        title: story.name,
        description: description,
        image: image,
        url: `${config.SITE_URL}/${story.full_slug}`,
      };
    });

    return {
      hits: indexedStories,
    };
  };
  return {
    searchStoryblok,
  };
};
